@if (data$ | async; as data) {
  @if (data.link?.locUrl) {
    <cx-generic-link [url]="data.link?.locUrl ?? ''">
      <span class="thumbnail">
        <div class="img">
          <cx-media [container]="data.image"></cx-media>
        </div>
      </span>
      <span class="title">{{ data.link?.linkName }}</span>
    </cx-generic-link>
  } @else {
    <cx-generic-link [url]="data.link?.url ?? ''">
      <span class="thumbnail">
        <div class="img">
          <cx-media [container]="data.image"></cx-media>
        </div>
      </span>
      <span class="title">{{ data.link?.linkName }}</span>
    </cx-generic-link>
  }
}
